export function logWarning(message: string) {
	console.warn(`WARNING: ${message}`);
}

export function logError(message: string) {
	console.warn(`ERROR: ${message}`);
}

export function deprecationWarning(message: string) {
	console.debug(`DEPRECATION WARNING: ${message}`);
}

export function incorrectUsageWarning(componentName: string, message: string) {
	console.debug(`Incorrect use of ${componentName} component: ${message}`);
}
